import React, { useState, useEffect } from 'react';
import { racesAPI } from '../services/api';
import ChatBoard from '../components/ChatBoard';

function Chat() {
  const [races, setRaces] = useState([]);
  const [selectedRoom, setSelectedRoom] = useState('general');

  useEffect(() => {
    racesAPI.getRaces().then((response) => {
      if (response.success) {
        // Sort: open/upcoming first, then by date descending
        const sorted = (response.data.races || []).sort((a, b) => {
          const order = { open: 0, upcoming: 1, active: 2, completed: 3 };
          const oa = order[a.status] ?? 99;
          const ob = order[b.status] ?? 99;
          if (oa !== ob) return oa - ob;
          return new Date(b.raceDate) - new Date(a.raceDate);
        });
        setRaces(sorted);
      }
    }).catch(() => {});
  }, []);

  const selectedRace = races.find((r) => r.raceId === selectedRoom);
  const chatTitle =
    selectedRoom === 'general'
      ? 'General Chat'
      : `🏇 ${selectedRace?.raceName || selectedRoom}`;

  return (
    <div className="chat-page" style={{ maxWidth: '800px', margin: '0 auto' }}>
      <div className="card">
        {/* Room selector */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1rem', flexWrap: 'wrap' }}>
          <label htmlFor="chat-room-select" style={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>
            Chat Room:
          </label>
          <select
            id="chat-room-select"
            value={selectedRoom}
            onChange={(e) => setSelectedRoom(e.target.value)}
            style={{
              flex: 1,
              minWidth: '180px',
              padding: '0.5rem 0.75rem',
              borderRadius: '6px',
              border: '1px solid #ddd',
              fontSize: '0.95rem',
              background: 'white',
              cursor: 'pointer',
            }}
          >
            <option value="general">— General Chat —</option>
            {races.length > 0 && (
              <optgroup label="Race Chats">
                {races.map((race) => (
                  <option key={race.raceId} value={race.raceId}>
                    {race.raceName}
                    {race.status === 'completed' ? ' ✓' : race.status === 'open' ? ' 🟢' : ''}
                  </option>
                ))}
              </optgroup>
            )}
          </select>
        </div>

        <ChatBoard
          key={selectedRoom}
          title={chatTitle}
          raceId={selectedRoom === 'general' ? null : selectedRoom}
        />
      </div>
    </div>
  );
}

export default Chat;
